import { Link } from 'react-router-dom'
import { TIKTOK_URL, INSTAGRAM_URL, LINKEDIN_URL, TWITTER_URL } from 'utilities/constants'
import InstagramIcon from 'assets/brands/Instagram'
import TiktokIcon from 'assets/brands/Tiktok'
import TwitterIcon from 'assets/brands/Twitter'
import LinkedinIcon from 'assets/brands/Linkedin'
import c from 'classnames'
import styles from './Social.module.scss'

export const SocialComponent = () => {
    return (
        <div className={c(
            styles.wrapper,
            'animate__animated animate__flipInX animate__delay-4s'
        )}>
            <h3 className={styles.title}>¡Sumate a nuestra comunidad!</h3>
            <div className={styles.links}>
                <Link to={TIKTOK_URL} target='_blank' className={styles.link}>
                    <TiktokIcon height={16} width={16} />
                </Link>
                <Link to={INSTAGRAM_URL} target='_blank' className={styles.link}>
                    <InstagramIcon height={16} width={16} />
                </Link>
                <Link to={LINKEDIN_URL} target='_blank' className={styles.link}>
                    <LinkedinIcon height={16} width={16} />
                </Link>
                <Link to={TWITTER_URL} target='_blank' className={styles.link}>
                    <TwitterIcon height={16} width={16} />
                </Link>
            </div>
        </div>
    )
}